import React, { memo } from "react";

import Media from "./Media";
import Extra from "./Extra";
import Sobre from './Sobre'
import SaibaMais from "./Extra/SaibaMais";

// Wrapper components for components with hooks
const MediaWrapper = React.forwardRef((props, ref) => <Media {...props} ref={ref} />);
const ExtraWrapper = React.forwardRef((props, ref) => <Extra {...props} ref={ref} />);
const SobreWrapper = React.forwardRef((props, ref) => <Sobre {...props} ref={ref} />);
const SaibaMaisWrapper = React.forwardRef((props, ref) => <SaibaMais {...props} ref={ref} />);

// Functional component with hooks
const MainContent = ({ tags = [], selected }) => {
  const isAbout = React.useMemo(() => {
    if(tags.length > 0) {
      return tags.includes("ABOUT");
    }
    return false;
  }, [tags]);

  let main;
  if (isAbout && !selected.showKnowMore) {
    main = <SobreWrapper />;
  } else if(selected.showKnowMore) {
    main = <SaibaMaisWrapper />;
  } else {
    main = <MediaWrapper />;
  }

  return (
    <React.Fragment>
      {main}
      {selected.type !== 'SCORM' && <ExtraWrapper />}
    </React.Fragment>
  );
};

// Pure function component wrapper
const Main = React.forwardRef((props, ref) => {
  return <MainContent {...props} ref={ref} />;
});

export default memo(Main);
